/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import React from 'react';
import './Statistiques.css';

export default function Statistiques({
  stats,
  objectives,
  message = 'Statistiques de la plateforme.'
}) {
  const entries = [
    {
      key: 'curieux',
      label: 'Curieux',
      value: Number(stats.curieux)    || 0,
      objective: Number(objectives.curieux)
    },
    {
      key: 'innovations',
      label: 'Innovations',
      value: Number(stats.innovations)|| 0,
      objective: Number(objectives.innovations)
    },
    {
      key: 'besoins',
      label: 'Besoins',
      value: Number(stats.besoins)    || 0,
      objective: Number(objectives.besoins)
    },
    {
      key: 'apporteurs',
      label: 'Apporteurs d’affaires',
      value: Number(stats.apporteurs) || 0,
      objective: Number(objectives.apporteurs)
    },
    {
      key: 'soutiens',
      label: 'Investisseurs',
      value: Number(stats.soutiens)   || 0,
      objective: Number(objectives.soutiens)
    },
    {
      key: 'promoteurs',
      label: 'Solutions',
      value: Number(stats.promoteurs) || 0,
      objective: Number(objectives.promoteurs)
    }
  ];

  return (
    <section className="statistiques">
      <header className="statistiques__header">
        <h2 className="statistiques__title">Statistiques</h2>
        <p className="statistiques__subtitle">{message}</p>
      </header>

      <div className="statistiques__grid">
        {entries.map(e => {
          const pct = e.objective > 0
            ? Math.round((e.value / e.objective) * 100)
            : 0;

          return (
            <article
              key={e.key}
              className="statistiques__card"
              aria-labelledby={`stat-${e.key}`}
            >
              <div className="statistiques__card-top">
                <div id={`stat-${e.key}`} className="statistiques__label">
                  {e.label}
                </div>
                <div className="statistiques__value" aria-hidden="true">
                  {e.value}
                </div>
              </div>

              <div
                className="statistiques__bar"
                role="progressbar"
                aria-valuemin="0"
                aria-valuemax="100"
                aria-valuenow={pct}
              >
                <div
                  className="statistiques__bar-fill"
                  style={{ width: `${pct}%` }}
                />
              </div>

              <div className="statistiques__pct">{pct}%</div>
            </article>
          );
        })}
      </div>
               <p className="launch-note">
    Pendant la phase de lancement, les statistiques sont fixes et données à titre d'exemple.
  </p>
    </section>
  );
  
}

